<template>
	<div id="partner">
    <div class="top">
    	<div>已练习：<span class="red">{{ count }}</span>次</div>
		  <a class="btn-end" @click="stopPrict">结束练习</a>

    </div>
    <div class="hawkeye">
    	<div class="left">
    		<div class="iframe-box">
					<iframe src="/hawkeyeVue/#/service/index" width="100%" height="100%" frameborder="0"></iframe>
  			</div>
    	</div>
    	<div class="right" >
    		<div class="header">练习得分</div>
    		<div class="content">
    			<!--评分结果-->
    				<div class="video">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div>
    			      <template v-if="gradeState == 1">
						<p>点评自己的练习</p>
						<div class="box otherbox">
							<template v-for="(f, index) in gradeList">
								<!-- <p class="name">{{ f.name }}</p> -->
								<template v-for="(s, key) in f.childList">

									<div class="topicformat">
										<div class="second name SpecialSymbol"><span>*</span>{{ s.name }}</div>
									<div class="SpecialSymboltext">
										<p class="second " v-for="(t, tkey) in s.childList">
										<el-radio v-model="s.checked" :label="t.id">{{ t.name }}</el-radio>
									</p>
									</div>
									</div>
								</template>
							</template>
						</div>
						<div class="save"><a @click="saveScore">确认自评</a></div>
    			</template>
    			<template v-else-if="gradeState == 2">
					
						<div class="table">
             <div v-if="complete=='no' && Clickrecord">
                <div class="bottom">
					 <!-- //为false -->

				  <div class="content" v-if="Clickrecord">
					  <!--评分结果-->
						<!-- <h3>{{existAdvise ? '练习得分与建议' : '练习得分'}}</h3> -->
		  			<!-- <audio :src="videoUrl" controls="controls"></audio> -->
					  <!-- <div class="video ivideo">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div> -->
						<!-- <h3>练习评分({{gradeScore}})</h3> -->
						<el-table :data="afterArry" :span-method="objectSpanMethod" :header-cell-style="rowsClass" :cell-class-name='addsClass' border style="width: 100%;">
				      <el-table-column  label="练习内容"  align="center" >
					  <el-table-column prop="parentname" width="50px" align="center"></el-table-column>
					  <el-table-column prop="name" width="50px" align="center"></el-table-column>
									  	 
					  </el-table-column>
				      <!-- <el-table-column prop="name" label="二级内容" width="150" align="center"></el-table-column> -->
					    <el-table-column prop="gradeScore" label="总分" width="50px" align="center">
							<template slot-scope="scope">
						         <div class="isblue">{{scope.row.gradeScore}}</div>
                    </template>
						</el-table-column>
				      <el-table-column label="自评分" align="center">
						    <el-table-column  label="扣分"  align="center" width="60px">
								<template slot-scope="scope">
									<el-tooltip placement="top">
									  <div class="text-style">
                                         <span class="DeductPoints" v-if="scope.row.gradeScore-scope.row.score!=0">-{{scope.row.gradeScore-scope.row.score}}分</span>
						                 <span class="DeductionDetails">({{scope.row.selfDp}})</span>
						            </div>
									
                                     <div slot="content">{{scope.row.selfDp}}</div>

                                   </el-tooltip>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                             
                    </template>
							</el-table-column>
                <el-table-column  prop="score" label="得分" width="60px" align="center" >
					<template slot-scope="scope">
						         <div class="isblue">{{scope.row.score}}</div>
                    </template>
				</el-table-column>
             

				      </el-table-column>
					    <!-- <el-table-column prop="checkedName" label="点评"  align="center"></el-table-column> -->
				     <el-table-column   label="练习建议" align="center" width="150px">
							
							 <template slot-scope="scope">
								 <el-tooltip placement="top">
									<div class="text-style">
									   <span class="isred">{{ scope.row.description }}</span>
									</div>
								    <div slot="content">{{scope.row.description}}</div>

                                   </el-tooltip>
                             
                             
                    </template>
				 
                </el-table-column>
				    </el-table>
  		       </div>
				</div>
			 </div>
			 <!-- // -->
             <div v-if="complete=='yes'">
                <div class="bottom">
  		        <div class="content" v-if="Clickrecord==false">
					  <!--评分结果-->
						<!-- <h3>{{existAdvise ? '练习得分与建议' : '练习得分'}}</h3> -->
		  			<!-- <audio :src="videoUrl" controls="controls"></audio> -->
					  <!-- <div class="video ivideo">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div> -->
						<!-- <h3>练习评分({{gradeScore}})</h3> -->
						<el-table :data="gradeList2" :span-method="objectSpanMethod" :header-cell-style="rowsClass" :cell-class-name='addsClass' border style="width: 100%;">
				      <el-table-column  label="练习内容"  align="center" >
					  <el-table-column prop="parentname" width="60px" align="center"></el-table-column>
					  <el-table-column prop="name" width="60px" align="center"></el-table-column>
									  	 
					  </el-table-column>
				      <!-- <el-table-column prop="name" label="二级内容" width="150" align="center"></el-table-column> -->
					    <el-table-column prop="gradeScore" label="总分" width="50px" align="center">
							<template slot-scope="scope">
						         <div class="isblue">{{scope.row.gradeScore}}</div>
                                 </template>
						</el-table-column>
				      <el-table-column label="自评分" align="center">
						    <el-table-column  label="扣分"  align="center" width="60px">
								<template slot-scope="scope">
									<el-tooltip placement="top">
									  <div class="text-style">
                                         <span class="DeductPoints" v-if="scope.row.gradeScore-scope.row.score!=0">-{{scope.row.gradeScore-scope.row.score}}</span>
						                 <span class="DeductionDetails">({{scope.row.checkedName}})</span>
						            </div>
									
                                     <div slot="content">{{scope.row.checkedName}}</div>

                                   </el-tooltip>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                             
                    </template>
							</el-table-column>
                <el-table-column  prop="score" label="得分" width="80px" align="center" >
					<template slot-scope="scope">
						         <div class="isblue">{{scope.row.score}}</div>
                    </template>
				</el-table-column>
             

				      </el-table-column>
					    <!-- <el-table-column prop="checkedName" label="点评"  align="center"></el-table-column> -->
				     <el-table-column  label="练习建议" align="center" width="150px">
							
							 <template slot-scope="scope">
								 <el-tooltip placement="top">
									<div class="text-style">
									   <span class="isred">{{ scope.row.description }}</span>
									</div>
								    <div slot="content">{{scope.row.description}}</div>

                                   </el-tooltip>
                             
                             
                    </template>
				 
                </el-table-column>
				    </el-table>
  		       </div>
				<!-- //有历史记录并且点了提交 -->
				 <div class="content" v-if="Clickrecord">
					  <!--评分结果-->
						<!-- <h3>{{existAdvise ? '练习得分与建议' : '练习得分'}}</h3> -->
		  			<!-- <audio :src="videoUrl" controls="controls"></audio> -->
					  <!-- <div class="video ivideo">
    				<span>练习录音</span>
						<audio :src="videoUrl" controls="controls"></audio>
					</div> -->
						<!-- <h3>练习评分({{gradeScore}})</h3> -->
						<el-table :data="afterArry" :span-method="objectSpanMethod" :header-cell-style="rowsClass" :cell-class-name='addsClass' border style="width: 100%;">
				      <el-table-column  label="练习内容"  align="center" >
					  <el-table-column prop="parentname" width="50px" align="center"></el-table-column>
					  <el-table-column prop="name" width="50px" align="center"></el-table-column>
									  	 
					  </el-table-column>
				      <!-- <el-table-column prop="name" label="二级内容" width="150" align="center"></el-table-column> -->
					    <el-table-column prop="gradeScore" label="总分" width="50px" align="center">
								<template slot-scope="scope">
						         <div class="isblue">{{scope.row.gradeScore}}</div>
                                 </template>
						</el-table-column>
				      <el-table-column label="自评分" align="center">
						    <el-table-column  label="扣分"  align="center" width="60px">
								<template slot-scope="scope">
									<el-tooltip placement="top">
									  <div class="text-style">
                                         <span class="DeductPoints" v-if="scope.row.gradeScore-scope.row.score!=0">-{{scope.row.gradeScore-scope.row.score}}分</span>
						                 <span class="DeductionDetails">({{scope.row.selfDp}})</span>
						            </div>
									
                                     <div slot="content">{{scope.row.selfDp}}</div>

                                   </el-tooltip>
                              <!-- {{ scope.row.score-scope.row.gradeScore}} -->
                             
                    </template>
							</el-table-column>
                <el-table-column  prop="score" label="得分" width="60px" align="center" >
					<template slot-scope="scope">
						         <div class="isblue">{{scope.row.score}}</div>
                                 </template>
				</el-table-column>
             

				      </el-table-column>
					    <!-- <el-table-column prop="checkedName" label="点评"  align="center"></el-table-column> -->
				     <el-table-column  label="练习建议" align="center" width="150px">
							
							 <template slot-scope="scope">
								 <el-tooltip placement="top">
									<div class="text-style">
									   <span class="isred">{{ scope.row.description }}</span>
									</div>
								    <div slot="content">{{scope.row.description}}</div>

                                   </el-tooltip>
                             
                             
                    </template>
				 
                </el-table-column>
				    </el-table>
  		       </div>
  	       </div>
		</div>
                        </div>
				
				</template>
	    		
	    		<template v-else>
	    			<div class="init">
		  				<!--初始化-->
		    			<p><img src="@/assets/images/voiceScene/icon_kong.png" /></p>
		    			<p>完成本次练习后</p>
		    			<p>才能给自己打分哦</p>
		    		</div>
	  			</template>
				  <el-dialog
					title=""
					:visible.sync="centerDialogVisible"
					width="30%"
					center>
					<span>你还有未点评的内容，还不能确认自评哦～</span>
					<span slot="footer" class="dialog-footer">
						<!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
						<el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
					</span>
					</el-dialog>
    		</div>
    	</div>
		
		
		
    </div>
    <div class="confirmbox-bg" v-if="gradeState == 1"></div>
    <div class="confirmbox" v-if="gradeState == 1">
    	<div class="head">
    		<span class="tip">提示</span>
    	</div>
    	<div class="text">
    		<p><img src="@/assets/images/voiceScene/icon_tips.png" /></p>
    		<p>请先完成自评~</p>
    	</div>
    </div>
    <div class="confirmbox-bg" v-if="isShowRecord"></div>
    <div class="confirmbox record" v-if="isShowRecord">
    	<div class="head">
    		<span class="tip">提示</span>
			<div @click="isShowRecord = false" style="font-weight:bold">x</div>
    	</div>
    	<div class="text">
    		<p><img src="@/assets/images/voiceScene/icon_tips.png" /></p>
    		<p>辛苦了，练了这么久！</p>
    		<p>休息一下听听别人的录音吧，</p>
    		<p>多学习才能让自己更上一层楼！</p>
    		<div class="save" @click="goRecord">去听录音</div>
    	</div>
    </div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				id: '',
				count: 0,
				callId: '',
				videoUrl: '', //录音文件
				gradeState: null, //评分状态
				gradeScore: '', //得分
				gradeList: '', //点评内容
				evaluateList: [], //练习建议
				teacherGradeList: [], //老师打分
				afterArry: [], //表格数据
				spanArr: [],
				pos: 0,
				keyData: 0, //更新页面
				isShowRecord: false, //是否达标听优秀录音
				tabId: null, //技能提升tab
				sceneMajorId: null, //场景id
				gradeScore1:'',//表单练习得分
				gradeList2: '', //点评内容
				complete:'no', //是否点击提交自评
				selfassessment:false, //判断是否自评（表单显现）
				existAdvise : false ,//是否显示 系统建议
				Clickrecord:false,//判断是否点击通话查看历史评分
				isexistAdvise:false ,   //判断是否有建议（旧数据）
				courseId:null,
				knowledgeSeq:null,
				CourseLevel:null,
				sceneId:null,
				trainId:null,
				tjkId:null,
				knowledgeId:null,
				centerDialogVisible:false//提示弹窗
			}
		},
		watch: {

		},
		created() {
			window.getCallId = this.getCallId;
		},
		mounted() {
			this.queryExerciseCount();
			this.queryCallNoSelfValuate();
		},
		methods: {
			//点击结束练习
       stopPrict() {
          this.$http.get(API_ROOT.college + `/voice/exercise/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
              if(result.data.success) {
                  this.step = 'second';
              }
          });
        
      },
          //更改某一列样式
    // addsClass({row,column,rowIndex,columnIndex}){ 
    //    if(columnIndex==3){  //此判断为第四列
    //       return 'addBorderStyle_3'
    //     }
	// 	 if(columnIndex==4){  //此判断为第五列
    //       return 'addBorderStyle_4'
    //     }
    // },



			 rowsClass({ row, column,rowIndex,columnIndex}) {

        if(rowIndex===0 && columnIndex===0) {
          this.$nextTick(()=> {
            if(document.getElementsByClassName(column.id).length!==0) {
              document.getElementsByClassName(column.id)[0].setAttribute('rowSpan',2);
              return false
            }
          })
        }
        if(rowIndex===1 && (columnIndex===0 || columnIndex===1)) {
          return {display:'none'}
        }
		if(columnIndex==3 && rowIndex==0 ){
			return 'background-color:#f9dbd0 !important '
		}else if(columnIndex==3 && rowIndex==1){
			return 'background-color:#cbd5fa !important'
		}
		 if(columnIndex==2  ){
			return 'background-color:#cbd5fa !important'
		}

      },
	  //提交查询
			uploadqueryGrade(id) {
				let self = this;
				let data = {
					'id': id
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryDetail', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.gradeScore1 = result.data.gradeScore;
						this.gradeList2 = [];
						const teacherGradeMap = new Map();
						if(result.data.teacherGradeList != null) {
							result.data.teacherGradeList.map((item) => {
						item.childList.map((obj) => {
						let checkedId = '';
						let checkedName = '';
						obj.childList.map((o) => {
							if(o.checked) {
							checkedId = o.id;
							}
						})

						let tempObj = {
							'score': obj.gradeScore,
							'childList': obj.childList,
							'checkedId': checkedId
						}
						teacherGradeMap.set(obj.id, tempObj);
							})
						})
			}else if(result.data.gradeList != null){
              result.data.gradeList.map((item) => {
                item.childList.map((obj) => {
                  let checkedId = '';
                  let checkedName = '';
                  let tempObj = {
                    'childList': obj.childList,
                    'checkedId': checkedId
                  }
                  teacherGradeMap.set(obj.id, tempObj);
                })
              })

						}
						if(result.data.gradeList != null) {
							result.data.gradeList.map((item) => {
								item.childList.map((obj) => {
									let checkedId = '';
									let checkedName = '';
									let description = '';
									obj.childList.map((o) => {
										if(o.checked) {
											checkedId = o.id;
											checkedName = o.name;
											description = o.description;
										}
									})
									let teacherGradeObj = teacherGradeMap.get(obj.id);
									let tempObj = {
										'parentname': item.name,
										'name': obj.name,
										'score': obj.gradeScore,
										'gradeScore':obj.score,
										'childList': obj.childList,
										'checkedId': checkedId,
										'checkedName': checkedName,
										'description': description,
										'teacherGrade': teacherGradeObj ? teacherGradeObj : {}
									}
									self.gradeList2.push(tempObj);
                                    //判断是否有建议，无建议，则不显示“系统建议”那一列
                                    if(this.existAdvise == false && description/* != null && description.trim() != ''*/){
                                        this.existAdvise = true;
                                    }
								})
							})
						}
						this.getSpanArr(this.gradeList2);
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},

			//接收callId
			getCallId(id) {
				console.log('传进来的callId------'+id)
				this.callId = id;
				this.queryGrade();
			},
			//查询对练次数
			queryExerciseCount() {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryPartnerExerciseCount').then(response=>{
					var result = response.data;
					if(result.success) {
						this.count = result.data;
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//查询是否存在未自评数据
			queryCallNoSelfValuate() {
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryCallNoSelfValuate?type=Each').then(response=>{
					var result = response.data;
					if(result.success) {
						if(result.data != null) {
							this.id = result.data.id;
						this.videoUrl = result.data.videoUrl;
						this.gradeState = result.data.gradeState;
						this.gradeScore = result.data.gradeScore;
						this.evaluateList = result.data.evaluateList;
						this.gradeList = result.data.gradeList;
						this.teacherGradeList = result.data.teacherGradeList;
						if(this.gradeList != null) {
							this.gradeList.map((item) => {
								item.childList.map((obj) => {
									obj.isClickSecond = false;
								})
							})
						}
						this.afterArry = [];
						//if(result.data.teacherGradeList != null) {
							for(let i=0;i<this.gradeList.length;i++) {
								for(let c=0;c<this.gradeList[i].childList.length;c++) {
									for(let ic=0;ic<this.gradeList[i].childList[c].childList.length;ic++) {
										let selfDp = '',
												teacherDp = '';
										if(this.gradeList[i].childList[c].childList[ic].checked) {
											selfDp = this.gradeList[i].childList[c].childList[ic].name;
											//for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
												//if(this.teacherGradeList[i].childList[c].childList[j].checked) {
													//teacherDp = this.gradeList[i].childList[c].childList[j].name;
													//break;
												//}
											//}
											let tempObj = {
												'parentname': this.gradeList[i].name,
												'name': this.gradeList[i].childList[c].name,
												'score': this.gradeList[i].childList[c].gradeScore,
												
												'selfDp': selfDp,
												'teacherDp': teacherDp,
												'description': this.gradeList[i].childList[c].childList[ic].description,
												'teacherScore': null//this.teacherGradeList[i].childList[c].gradeScore
											}
											this.afterArry.push(tempObj);

											break;
										}
									}
								}
							}
							this.getSpanArr(this.afterArry);
						//}
						}
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//查询评分结果
			queryGrade() {
				let self = this;
				let data = {
					'callId': this.callId
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryPartnerGrade', data).then(response=>{
					var result = response.data;
					if(result.success) 
					
					{
						this.Clickrecord=true
						this.id = result.data.id;
						this.videoUrl = result.data.videoUrl;
						this.gradeState = result.data.gradeState;
						this.gradeScore = result.data.gradeScore;
						this.evaluateList = result.data.evaluateList;
						this.gradeList = result.data.gradeList;
						this.teacherGradeList = result.data.teacherGradeList;
						if(this.gradeList != null) {
							this.gradeList.map((item) => {
								item.childList.map((obj) => {
									obj.isClickSecond = false;
								})
							})
						}
						this.afterArry = [];
						//if(result.data.teacherGradeList != null) {
							let tempObj = {}
							for(let i=0;i<this.gradeList.length;i++) {
								for(let c=0;c<this.gradeList[i].childList.length;c++) {
									for(let ic=0;ic<this.gradeList[i].childList[c].childList.length;ic++) {
										let selfDp = '',
												teacherDp = '';
										if(this.gradeList[i].childList[c].childList[ic].checked) {
											selfDp = this.gradeList[i].childList[c].childList[ic].name;
											//for(let j=0;j<this.teacherGradeList[i].childList[c].childList.length;j++) {
												//if(this.teacherGradeList[i].childList[c].childList[j].checked) {
													//teacherDp = this.gradeList[i].childList[c].childList[j].name;
													//break;
												//}
											//}
											tempObj = {
												'parentname': this.gradeList[i].name,
												'name': this.gradeList[i].childList[c].name,
												'score': this.gradeList[i].childList[c].gradeScore,
												'gradeScore':this.gradeList[i].childList[c].score,
												'selfDp': selfDp,
												'teacherDp': teacherDp,
												'description': this.gradeList[i].childList[c].childList[ic].description,
												'teacherScore': null//this.teacherGradeList[i].childList[c].gradeScore
											}
											this.afterArry.push(tempObj);
									
											break;
										}
									}
								}
							}
							this.getSpanArr(this.afterArry);
							console.log(tempObj, '《==================obj')
									 if(this.isexistAdvise == false && tempObj && tempObj.description && tempObj.description.length()!=0/* != null && description.trim() != ''*/){
                                        this.isexistAdvise = true;
                                    }
						//}
					}
					else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//点击二级菜单
			clickSecond(index, key) {
				this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
				this.keyData+=1;
			},
			//提交评分
			saveScore() {
				let choiceRuleIds = [];
						
				for(let i=0;i<this.gradeList.length;i++) {
					for(let j=0;j<this.gradeList[i].childList.length;j++) {
						if(!this.gradeList[i].childList[j].checked) {
							this.centerDialogVisible=true
							// this.$alert('练习点评为必选');
							return false;
							break;
						}else {
							choiceRuleIds.push(this.gradeList[i].childList[j].checked);
						}
					}
				}

				let data = {
					'id': this.id,
					'callId': this.callId,
					'choiceRuleIds': choiceRuleIds
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/savePartnerGrade', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.$alert('你已完成本次自评');
						// 以前是保存成功
						this.queryGrade();
						//查询是否达标听优秀录音
						this.showGoodVoicePopWin();
							this.selfassessment=true
						this.uploadqueryGrade(result.data)
                        this.complete='yes'
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			showGoodVoicePopWin() {
				this.$http.post(API_ROOT.college + '/goodRecord/showGoodVoicePopWin').then(response=>{
					var result = response.data;
					if(result.success) {
						this.isShowRecord = result.data.jumpGoodVoice ? true : false;

						this.knowledgeId=result.data.knowledgeId
						this.courseId=result.data.courseId;
						this.knowledgeSeq=result.data.knowledgeSeq;
						this.CourseLevel=result.data.CourseLevel;
						this.sceneId=result.data.sceneId;
						this.trainId=result.data.trainId;
						this.tjkId=result.data.tjkId;
						
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//听录音
			goRecord() {
				this.$router.push({path: '/vedioDetail', query: {courseId:this.courseId,knowledgeSeq:this.knowledgeSeq,CourseLevel:this.CourseLevel,sceneId:this.sceneId,trainId:this.trainId,tjkId:this.tjkId,knowledgeId:this.knowledgeId,isReture:'yes'}});
			},
			getSpanArr(data) {
				this.spanArr = [];
				this.pos = 0;
				for (var i = 0; i < data.length; i++) {
					if(i === 0) {
						// 如果是第一条记录（即索引是0的时候），向数组中加入１
						this.spanArr.push(1);
						this.pos = 0;
					}else {
						if(data[i].parentname=== data[i - 1].parentname) {
							// 如果name相等就累加，并且push 0 （这里的判断视自己的判定依据改变,name就是要对比的字段）
							this.spanArr[this.pos] += 1;
							this.spanArr.push(0);
						}else {
							// 不相等push 1
							this.spanArr.push(1);
							this.pos = i;
						}
					}
				}
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }) {
				// 用于设置要合并的列 0 表示第一列
				if (columnIndex === 0) {
					const cRow = this.spanArr[rowIndex];
					const cCol = cRow > 0 ? 1 : 0;
					return {
						rowspan: cRow, // 合并的行数
						colspan: cCol // 合并的列数，为0表示不显示
					}
				}
			},
			addsClass({row,column,rowIndex,columnIndex}) {
	    //   if(columnIndex == 2 || columnIndex == 3) {
	    //     return 'self';
	    //   }
	    //   if(columnIndex == 4 || columnIndex == 5) {
	    //     return 'teacher';
	    //   }
		// 修改样式
		  if(columnIndex==3){  //此判断为第四列
          return 'addBorderStyle_3'
        }
		 if(columnIndex==4){  //此判断为第五列
          return 'addBorderStyle_4'
        }
	    }
		}
	}
</script>

<style lang="less" scoped>
	.record {
		p {
			line-height: 25px;
		}
		.save {
			display: inline-block;
      background-color: #497AF2;
      color: #fff;
      border-radius: 6px;
      width: 80px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      margin-right: 15px;
      margin-bottom: 10px;
      margin-top: 10px;
		}
	}
	.ivideo{    background-color: #252733;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    align-items: center;}
.ivideo>span{color: #fff;
    width: 80px;}
	.topicformat{display:flex;justify-content: left;
	border-bottom: 10px solid #fff;padding: 10px 0;}
	.SpecialSymbol{width: 23%;display: inline-block;}
	.SpecialSymboltext{width: 70%;}
	.SpecialSymbol>span{color: red;}
	.otherbox{padding: 10px 0 !important}
	.text-style{text-overflow: ellipsis;
	white-space: nowrap;overflow: hidden;}
	.DeductPoints{color: red;font-weight: 600;width:auto;}
	.isblue{color:#6982D6 ;font-weight: 600;width:auto;}
.isred{color: red;}

.DeductionDetails{color:#d3d3d3;}
.addBorderStyle_4{border-right: solid 2px #acb9e0 !important;}
.text-style{text-overflow: ellipsis;
	white-space: nowrap;}
</style>


// WEBPACK FOOTER //
// ./src/page/newVoiceScene/partner.vue